/**
 * For anything that needs access to the receipts for voting.
 *
 * Assumes something is defining this.motion
 *
 * @type {{vote: ((function(): (*|undefined))|*)}}
 */
const {isReadyToRock} = require("../utilities/readiness.utilities");
module.exports = {

    computed: {
    // asyncComputed: {
        /**
         * A vote object if one exists for the given motion
         * @returns {*}
         */
        vote: function () {
            if (!_.isNull(this.motion) && !_.isUndefined(this.motion)) return this.$store.getters.getCastVoteForMotion(this.motion);
        },

        receipt: function () {
            if (!_.isNull(this.vote) && !_.isUndefined(this.vote)) return this.vote.receipt;
            return '';
        },

        /**
         * Returns a string yay or nay representing how the user
         * voted if that is stored on the object.
         * Returns null otherwise
         * @returns {string}
         */
        voteContent: function () {
            if(isReadyToRock(this.vote)) return this.vote.voteDisplayEnglish();
        },

        showVoteContent: function () {
            return isReadyToRock(this.voteContent);
        }

    }
};
